import { render, staticRenderFns } from "./CoursePlanItem.vue?vue&type=template&id=355da519&"
import script from "./CoursePlanItem.vue?vue&type=script&lang=js&"
export * from "./CoursePlanItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports